import { Link } from "@tanstack/react-router";
import { ChevronDown, Home, Settings, Users } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { NavLink } from "./NavLink";

// Desktop (≥md) primary nav. Lives to the right of the brand on the dark
// header bar. Operations dropdown is conditional on the user's role.
export function DesktopNav({
  pathname,
  isAdmin,
  showOperations,
}: {
  pathname: string;
  isAdmin: boolean;
  showOperations: boolean;
}) {
  const opsActive = pathname.startsWith("/teams");
  return (
    <nav className="ml-auto hidden items-center gap-1 md:flex">
      <NavLink to="/home" isActive={pathname === "/home"}>
        <Home className="size-4" />
        Home
      </NavLink>

      {isAdmin && (
        <NavLink to="/config" isActive={pathname.startsWith("/config")}>
          <Settings className="size-4" />
          Configuration
        </NavLink>
      )}

      {showOperations && (
        <DropdownMenu>
          <DropdownMenuTrigger
            className={cn(
              "inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium outline-none transition-colors",
              opsActive
                ? "bg-primary-foreground/15 text-primary-foreground"
                : "text-primary-foreground/80 hover:bg-primary-foreground/10 hover:text-primary-foreground",
            )}
          >
            <Users className="size-4" />
            Operations
            <ChevronDown className="size-3.5 opacity-70" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuItem asChild>
              <Link to="/teams">Claim Teams</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/teams/history">Team History</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/teams/help">Team Help</Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </nav>
  );
}
